import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Link from '@zenbusiness/zui/Link';
import Stack from '@zenbusiness/zui/Stack';

import { login } from '#client/constants/routes';

import {
  InvoicePaymentsHeaderButton,
  InvoicePaymentsHeaderRoot,
  InvoicePaymentsHeaderWordmark,
} from './InvoicePaymentsHeader.style';

import { HELP_URL, HOME_URL, WORDMARK_LOGO_URL } from '../../constants';

export default function InvoicePaymentsHeader() {
  return (
    <InvoicePaymentsHeaderRoot>
      <Link href={HOME_URL}>
        <InvoicePaymentsHeaderWordmark alt="ZenBusiness" src={WORDMARK_LOGO_URL} />
      </Link>
      <Stack direction="row" gap={1} alignItems="center">
        <InvoicePaymentsHeaderButton href={HELP_URL} target="_blank" rel="noopener noreferrer">
          <FormattedMessage id="dashboard.invoicePayments.header.needHelp" />
        </InvoicePaymentsHeaderButton>
        <InvoicePaymentsHeaderButton to={login}>
          <FormattedMessage id="dashboard.invoicePayments.header.logIn" />
        </InvoicePaymentsHeaderButton>
      </Stack>
    </InvoicePaymentsHeaderRoot>
  );
}
